const state = {
  cropperHeight: null,
  cropperWidth: null,
  cropperTop: null,
  cropperLeft: null,
  cropperRotate: null,
}

const getters = {
  cropperHeight: state => state.cropperHeight,
  cropperWidth: state => state.cropperWidth,
  cropperTop: state => state.cropperTop,
  cropperLeft: state => state.cropperLeft,
  cropperRotate: state => state.cropperRotate,
}

const actions = {
  setCropperHeight({ commit }, data) {
    commit('setCropperHeight', data)
  },
  setCropperWidth({ commit }, data) {
    commit('setCropperWidth', data)
  },
  setCropperTop({ commit }, data) {
    commit('setCropperTop', data)
  },
  setCropperLeft({ commit }, data) {
    commit('setCropperLeft', data)
  },
  setCropperRotate({ commit }, data) {
    commit('setCropperRotate', data)
  },
}

const mutations = {
  setCropperHeight(state, value) {
    state.cropperHeight = value
  },
  setCropperWidth(state, value) {
    state.cropperWidth = value
  },
  setCropperTop(state, value) {
    state.cropperTop = value
  },
  setCropperLeft(state, value) {
    state.cropperLeft = value
  },
  setCropperRotate(state, value) {
    state.cropperRotate = value
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
